export const WORKFLOW_INIT = 'WORKFLOW_INIT';
export const WORKFLOW_LOAD = 'WORKFLOW_LOAD';
export const WORKFLOW_NEXT = 'WORKFLOW_NEXT';
export const WORKFLOW_RETRY = 'WORKFLOW_RETRY';
export const WORKFLOW_PREV = 'WORKFLOW_PREV';
export const WORKFLOW_SET_LOADING = 'WORKFLOW_SET_LOADING';
export const WORKFLOW_RETRY_LATEST_ACTION_STEP = 'WORKFLOW_RETRY_LATEST_ACTION_STEP';
